var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 70,
    viewBox: "0 0 215 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215 0H0C24.973 0 48.8419 21.1457 71.4232 41.1499C72.9908 42.5383 74.5497 43.9291 76.1003 45.3126C86.8957 54.9451 97.3044 64.2313 107.5 70C117.691 64.2342 128.094 54.9532 138.884 45.3261L138.891 45.3203C139.848 44.4663 140.809 43.6099 141.772 42.753C142.372 42.2187 142.974 41.6843 143.577 41.1499C166.158 21.1457 190.027 0 215 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSlice);
export default __webpack_public_path__ + "static/media/blackSlice.17363cc9a4fcef7dbee5307fba3376a6.svg";
export { ForwardRef as ReactComponent };